import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InvoicesList = _resolveComponent("InvoicesList")!
  const _component_BaseSheet = _resolveComponent("BaseSheet")!
  const _component_MainContentBase = _resolveComponent("MainContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Multiselect, {
        modelValue: _ctx.filterAssignedToInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterAssignedToInput) = $event)),
        placeholder: _ctx.t('filter.assignedTo'),
        options: _ctx.filterAssignedToOptions,
        closeOnSelect: true,
        canClear: true,
        disabled: false
      }, null, 8, ["modelValue", "placeholder", "options"]),
      _createVNode(_component_Multiselect, {
        modelValue: _ctx.filterCollectionStatusInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterCollectionStatusInput) = $event)),
        placeholder: _ctx.t('filter.collectionStatus'),
        options: _ctx.filterCollectionStatusOptions,
        closeOnSelect: true,
        canClear: true,
        disabled: false
      }, null, 8, ["modelValue", "placeholder", "options"]),
      _createVNode(_component_Multiselect, {
        modelValue: _ctx.filterClientsInput,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterClientsInput) = $event)),
        placeholder: _ctx.t('filter.client'),
        options: _ctx.filterClientsOptions,
        closeOnSelect: true,
        canClear: true,
        disabled: false,
        searchable: true
      }, null, 8, ["modelValue", "placeholder", "options"])
    ]),
    _createVNode(_component_MainContentBase, null, {
      default: _withCtx(() => [
        _createVNode(_component_BaseSheet, {
          class: "sheet",
          "tag-name": "section"
        }, {
          header: _withCtx(() => [
            _createElementVNode("h3", {
              class: "sheet__title",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.switchAreExpectedPaymentsVisible && _ctx.switchAreExpectedPaymentsVisible(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "entypo:triangle-right",
                rotate: _ctx.areExpectedPaymentsVisible ? 1 : 0,
                class: "icon-invoices-menu"
              }, null, 8, ["rotate"]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("titles.lateInvoices")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InvoicesList, {
                query: _ctx.GET_OPENED_INVOICES,
                "query-params": {
            lateFilter: _ctx.LateFilterOptions.DUE_AND_PROMISED_DATE_LATE,
            assignedToRole: [_ctx.InvoicingRole.ADMIN],
            collectionStatus: [_ctx.InvoiceCollectionStatus.EXPECTED_PAYMENT],
            ..._ctx.filteringInput,
          },
                refetchQueries: _ctx.refetchQueries,
                hasCheckBox: true,
                avatarColumn: 'assignedTo'
              }, null, 8, ["query", "query-params", "refetchQueries"])
            ], 512), [
              [_vShow, _ctx.areExpectedPaymentsVisible]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSheet, {
          class: "sheet",
          "tag-name": "section"
        }, {
          header: _withCtx(() => [
            _createElementVNode("h3", {
              class: "sheet__title",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.switchAreCompromisedInvoicesVisible && _ctx.switchAreCompromisedInvoicesVisible(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "entypo:triangle-right",
                rotate: _ctx.areCompromisedInvoicesVisible ? 1 : 0,
                class: "icon-invoices-menu"
              }, null, 8, ["rotate"]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("titles.toClean")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InvoicesList, {
                query: _ctx.GET_OPENED_INVOICES,
                "query-params": {
            lateFilter: _ctx.LateFilterOptions.DUE_AND_PROMISED_DATE_LATE,
            assignedToRole: [_ctx.InvoicingRole.ADMIN],
            ..._ctx.filteringInput_withOnlyCompromisedPayment,
          },
                refetchQueries: _ctx.refetchQueries,
                hasCheckBox: true,
                avatarColumn: 'assignedTo'
              }, null, 8, ["query", "query-params", "refetchQueries"])
            ], 512), [
              [_vShow, _ctx.areCompromisedInvoicesVisible]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSheet, {
          class: "sheet",
          "tag-name": "section"
        }, {
          header: _withCtx(() => [
            _createElementVNode("h3", {
              class: "sheet__title",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.switchAreDelayedInvoicesVisible && _ctx.switchAreDelayedInvoicesVisible(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "entypo:triangle-right",
                rotate: _ctx.areDelayedInvoicesVisible ? 1 : 0,
                class: "icon-invoices-menu"
              }, null, 8, ["rotate"]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("titles.delayedInvoice")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InvoicesList, {
                query: _ctx.GET_OPENED_INVOICES,
                "query-params": {
            lateFilter: _ctx.LateFilterOptions.DELAYED,
            assignedToRole: [_ctx.InvoicingRole.ADMIN],
            ..._ctx.filteringInput_includingAllCollectionStatus,
          },
                refetchQueries: _ctx.refetchQueries,
                hasCheckBox: true,
                avatarColumn: 'assignedTo'
              }, null, 8, ["query", "query-params", "refetchQueries"])
            ], 512), [
              [_vShow, _ctx.areDelayedInvoicesVisible]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_BaseSheet, {
          class: "sheet",
          "tag-name": "section"
        }, {
          header: _withCtx(() => [
            _createElementVNode("h3", {
              class: "sheet__title",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.switchAreFOInvoicesVisible && _ctx.switchAreFOInvoicesVisible(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "entypo:triangle-right",
                rotate: _ctx.areFOInvoicesVisible ? 1 : 0,
                class: "icon-invoices-menu"
              }, null, 8, ["rotate"]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("titles.financialOfficerInvoice")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_InvoicesList, {
                query: _ctx.GET_OPENED_INVOICES,
                "query-params": {
            assignedToRole: [_ctx.InvoicingRole.FINANCIAL],
            ..._ctx.filteringInput_includingAllCollectionStatus,
          },
                hasCheckBox: false,
                avatarColumn: 'assignedTo'
              }, null, 8, ["query", "query-params"])
            ], 512), [
              [_vShow, _ctx.areFOInvoicesVisible]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}